import React from 'react'
import { Select } from 'antd'

export const TagFilterMethod = (filter, row) => {
  console.log({ filter, row })
  const openArray = ['Doing', 'Urgent', 'Todo']

  if (filter.value === 'all') {
    return true
  }
  if (filter.value === 'Doing') {
    return row[filter.id] ? row[filter.id].join('-').includes('Doing') : false
  }
  if (filter.value === 'Urgent') {
    return row[filter.id] ? row[filter.id].join('-').includes('Urgent') : false
  }
  if (filter.value === 'Todo') {
    return row[filter.id] ? row[filter.id].join('-').includes('Todo') : false
  }

  return openArray.includes(row[filter.id])
}

function TagFilter({ onChange, filter }) {
  return (
    <Select
      onChange={value => onChange(value)}
      style={{ width: '100%' }}
      value={filter ? filter.value : 'all'}>
      <Select.Option value={'Doing'}>Doing</Select.Option>
      <Select.Option value={'Urgent'}>Urgent</Select.Option>
      <Select.Option value={'Todo'}>Todo</Select.Option>
      <Select.Option value="all">All</Select.Option>
    </Select>
  )
}

TagFilter.propTypes = {}
TagFilter.defaultProps = {}

export default TagFilter
